/**
 * The api `clearReplaceTarget` (protectedBranchFlow) takes for a Replace onto a folder: the old folder
 * is deleted through its job when it is big (#921 — an inline delete of a big folder is cut at the edge
 * while the server goes on), so the move waits for the truth. Its outcome carries what an undo record
 * needs (`binId`, `binIds`, `binnedFileIds`, `skipped`). Not an undo: it acts as the tab's own identity.
 */
import { filesApi, type PinnedIdentityOptions } from './index.js'
import { deleteUntilGone } from './undoHandlers.js'

export const replaceClearApi = {
  protectedBranches: (id: string, op: 'delete') => filesApi.protectedBranches(id, op),
  deleteFile: (id: string) => deleteUntilGone(id),
}

/** #1316 review round 2 — the same, for a step of a pinned batch (`pinnedBatch().opts()`): sent as the identity that
 *  started the batch, and its delete job followed to its end like an undo's (`runsToCompletion`). `opts` is read per
 *  call, so a step after the batch's session ended with an identity that can't be named refuses (it throws). */
export function replaceClearApiAs(opts: () => PinnedIdentityOptions) {
  return {
    protectedBranches: (id: string, op: 'delete') => filesApi.protectedBranches(id, op, undefined, opts()),
    deleteFile: (id: string) => {
      const identity = opts().identity
      return deleteUntilGone(id, identity ? { identity } : undefined)
    },
  }
}
